import { useDeviceStorage } from '../adapters/ports.js';

// Local persistence for the sales and auction houses the dealer follows, through the
// host's device-storage port. A follow is a fact about this device until the server
// holds them: another device signed in as the same dealer starts with none. Saving
// them to the account is a separate piece of work.
//
// Bump this suffix when the persisted shape changes so a stale value is discarded
// rather than mis-applied on the boot path.
const FOLLOWS_KEY = 'aac.follows.v1';

const names = (value) => (Array.isArray(value) ? value.filter((each) => typeof each === 'string') : []);

// Never rejects, and never returns a half-shape: the port answers null for both a
// missing value and a malformed one, and the field-by-field read below turns anything
// else unexpected into no follows.
export async function getFollows() {
  const parsed = await useDeviceStorage().getJson(FOLLOWS_KEY);
  if (!parsed || typeof parsed !== 'object') return { sales: [], houses: [] };
  return { sales: names(parsed.sales), houses: names(parsed.houses) };
}

export async function setFollows({ sales = [], houses = [] }) {
  await useDeviceStorage().setJson(FOLLOWS_KEY, { sales: names(sales), houses: names(houses) });
}

export async function clearFollows() {
  await useDeviceStorage().remove(FOLLOWS_KEY);
}

export const followStorage = { getFollows, setFollows, clearFollows };
export default followStorage;
